import type { LscJoinRequest } from './types';

export function shortenInviteCode(code?: string | null): string {
  if (!code) return '—';
  if (code.length <= 20) return code;
  return `${code.slice(0, 16)}…`;
}

export function formatJoinRequestDate(iso?: string | null): string {
  if (!iso) return '—';
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return iso;
  return parsed.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function formatJoinRequestUser(
  item: Pick<LscJoinRequest, 'twitch_login' | 'user_uid'>
): string {
  if (item.twitch_login) return `@${item.twitch_login}`;
  return item.user_uid || '—';
}

export function formatJoinRequestDiscord(
  item: Pick<LscJoinRequest, 'discord_username' | 'discord_id'>
): string {
  if (item.discord_username) return `@${item.discord_username}`;
  return item.discord_id || '—';
}

export function joinRequestActionsDisabled(
  leagueArchived: boolean,
  actingId: string | null,
  requestId: string
): boolean {
  return leagueArchived || actingId === requestId;
}
